import { cn } from '../../lib/cn';
import { getPoleColor } from './TicketPoleBadge';
import type { Tables } from '../../types/database.types';

type TicketCategory = Tables<'ticket_categories'>;

interface TicketCategoryBadgeProps {
  category: TicketCategory | null | undefined;
  className?: string;
}

export function TicketCategoryBadge({ category, className }: TicketCategoryBadgeProps) {
  if (!category) {
    return (
      <span
        className={cn(
          'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-neutral-100 text-neutral-400',
          className,
        )}
      >
        Non classé
      </span>
    );
  }

  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium',
        getPoleColor(category.pole),
        className,
      )}
    >
      {category.label}
    </span>
  );
}
